<template>
  <div class="first-step">
    <div class="border-box one"
      :class="{on: curIndex == -1}"
         @click="curIndex = -1"
    >
      <div class="box-top">
        <img
          src="../../assets/images/icon/img_transfer@1x.png"
          alt=""
          class="icon-img"
        >
        <span class="title">{{$t('Transfer_to_MT4_account')}}</span>
      </div>
      <div class="bottom-line">
        <p
          v-for="(item,index) in descs"
          :key="index"
        >{{item}}</p>
      </div>
    </div>
    <agent-withdraw-card
        card-index="1"
        :current-index="curIndex"
        :withdraw-pay-info="bankCardInfo"
        @send-whitdrawInfo="sendWhitdrawInfo"
    ></agent-withdraw-card>
    <agent-withdraw-card
        card-index="2"
        :current-index="curIndex"
        :withdraw-pay-info="usdtCardInfo"
        @send-whitdrawInfo="sendWhitdrawInfo"
    ></agent-withdraw-card>
    <agent-withdraw-card
        card-index="3"
        :current-index="curIndex"
        :withdraw-pay-info="otcCardInfo"
        @send-whitdrawInfo="sendWhitdrawInfo"
    ></agent-withdraw-card>
  </div>
</template>

<script>
// 出金
import bankIconUrl from '../../assets/images/founds/bankTw.png';
import usdtIconUrl from '../../assets/images/founds/usdtIcon.png';
import otcIconUrl from '../../assets/images/founds/otcIconNew.png';
import { getBankInfo } from '@/api/userCenter'
import agentWithdrawCard from "@/components/agent/withdraw/agentWithdrawCard";
import { mapGetters } from 'vuex';
export default {
  name: "firstStep",
  components: {
    agentWithdrawCard
  },
  props: {
    descs: {
    },
  },
  data() {
    return {
      curIndex: -1,

      bankInfo: {
        examineStatus: '',
        payDetailMap:{
          bankAccount: "",
          bankName: "",
          bankStatus: 0,
          firstName: "",
          lastName: "",
          swiftCode: "",
        },
        maximumLimit: 0,
        minimumLimit: 0,
      },
      usdtInfo:{
        payDetailMap:{
          address: "",
          qrPic: "",
        },
        maximumLimit: 0,
        minimumLimit: 0
      },
      otcInfo:{
        payDetailMap:{
          address: "",
          qrPic: "",
        },
        maximumLimit: 0,
        minimumLimit: 0
      },
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    currentWhitdrawInfo(){
      if(this.curIndex > -1){
        if(this.curIndex == 1){
          this.bankInfo.descs = this.bankCardInfo.descs;
           return this.bankInfo;
        }else if(this.curIndex == 2){
          this.usdtInfo.descs = this.usdtCardInfo.descs;
          return this.usdtInfo;
        }else if(this.curIndex == 3){
          this.otcInfo.descs = this.otcCardInfo.descs;
          return this.otcInfo;
        }
      }
    },

    bankCardInfo(){
      return {
        payTypeId: 7,
        channelName: this.$t('User.reportComiType1'),
        logoUrl: bankIconUrl,
        descs: [
          `1.${this.$t('User.limit')}$${this.bankInfo.minimumLimit}~$${this.bankMaximunLimit}。`,
          this.$t('withdrawBankCardTipsSecondLine'),
          // '3.' + this.$t('withdrawBankCardTipsThirdlyLine'),
        ]
      }
    },
    bankMaximunLimit(){
      return this.bankInfo.maximumLimt || '∞';
    },
    usdtCardInfo(){
      return {
        payTypeId: 8,
        channelName: this.$t('The_commission_to_USDT'),
        logoUrl: usdtIconUrl,
        descs: [
          `1.${this.$t('User.limit')}$${this.usdtMinimumLimit}~$${this.usdtMaximumLimit}。`,
          this.$t('withdrawUsdtTipsSecondLine'),
          // '3.' + this.$t('withdrawBankCardTipsThirdlyLine'),
        ]
      }
    },
    usdtMinimumLimit(){
      return this.usdtInfo.minimumLimit
    },
    usdtMaximumLimit(){
      return this.usdtInfo.maximumLimt || '∞';
    },
    otcCardInfo(){
      return {
        payTypeId: 9,
        channelName: this.$t('The_commission_to_OTC365'),
        logoUrl: otcIconUrl,
        descs: [
          `1.${this.$t('User.limit')}$${this.otcMinimumLimit}~$${this.otcMaximumLimit}。`,
          '2.' + this.$t('withdrawOtcTipsSecondLine'),
          // '3.' + this.$t('withdrawOtcTipThirdlyLine'),
          // '4.' + this.$t('withdrawBankCardTipsThirdlyLine'),
        ]
      }
    },
    otcMinimumLimit(){
      return this.otcInfo.minimumLimit;
    },
    otcMaximumLimit(){
      return this.otcInfo.maximumLimt || '∞';
    }
  },
  created(){
    this.getWithdrawList();
  },
  methods: {
    getWithdrawList(){
      getBankInfo({
        custId: this.userInfo.id,
        type: 2,
      }).then((res) => {
        this.withdrawList = res.data;
        for (let i = 0; i < res.data.length; i++) {
          if(res.data[i].payTypeId == 7){
            this.bankInfo = res.data[i];
          }
          if(res.data[i].payTypeId == 8){
            this.usdtInfo = res.data[i];
          }
          if(res.data[i].payTypeId == 9){
            this.otcInfo = res.data[i];
          }
        }
      })
    },
    channelHandle(index) {
      this.curIndex = index;
    },
    sendWhitdrawInfo(cardIndex){
      this.curIndex = cardIndex;
      setTimeout(() => {
        this.$emit('card-click',this.currentWhitdrawInfo);
      },200);
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variable";
.first-step {
  .border-box {
    cursor: pointer;
    padding: 15px;
    margin-bottom: 24px;
    border: 1px solid #D8D6DE;
    border-radius: 10px;
    &.on {
      border-color: $themeColor;
    }
    &.one {
      .box-top {
        margin-bottom: 0;
      }
    }
    .box-top {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 10px;
      .title {
        font-size: 16px;
        font-weight: 600;
        color: #5E5873;
      }
    }
    .icon-img {
      width: 24px;
      height: 24px;
      margin-right: 10px;
    }
    .tips {
      padding-left: 34px;
      color: #6E6B7B;
      font-size: 12px;
    }
  }
  .bottom-line {
    padding-left: 34px;
    padding-top: 15px;
    color: #6E6B7B;
  }
}
</style>
